import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import './ContractReassignment.css';
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faCircleArrowLeft,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import Select from "react-select";
import Loader from "../../components/Loader";

const ContractReassignment = ({ handleLogout }) => {
    const navigate = useNavigate();
    const [contract, setContract] = useState("");
    const [contractSearch, setContractSearch] = useState("");
    const [contractData, setContractData] = useState([]);
    const [customer, setClient] = useState("");
    const [clientSearch, setClientSearch] = useState("");
    const [clientsData, setClientsData] = useState([]);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [searchTermClient, setSearchTermClient] = useState(''); // Para el valor de búsqueda
    const [searchTermContract, setSearchTermContract] = useState(''); // Para el valor de búsqueda
    const [isContractSelected, setIsContractSelected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [messageBlock, setMessageBlock] = useState("");
    const [notificationBlock, SetNotificationBlock] = useState(false);

    const validateFields = () => {
        let validationErrors = {};
        if (!contract) validationErrors.contract = "El Campo es Obligatorio";
        if (!customer) validationErrors.customer = "El Campo es Obligatorio";
        return validationErrors;
    };


    const handleClick = () => {
        navigate(-1);
    };

    const handleCloseBlock = () => {
        SetNotificationBlock(false);
    };

    //BUSCAR CLIENTE 
    const handleSearchCustomer = useCallback(async (page = 1) => {
        try {
            const params = new URLSearchParams();
            if (searchTermClient) params.append('search', searchTermClient);

            const response = await apiClient.get(`/clients?${params.toString()}&page=${page}`);

            if (Array.isArray(response.data.results)) {
                setClientsData(response.data.results);
            } else {
                setClientsData([response.data.results]);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        }
    }, [searchTermClient]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTermClient) {
                handleSearchCustomer();
            }
        }, 200);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTermClient, handleSearchCustomer]);

    const handleClientChange = (selectedOption) => {
        if (selectedOption) {
            setClient(selectedOption.value);
            setClientSearch(selectedOption.label);
            //setClientsData([]);
        } else {
            setClient("");
            setClientSearch("");
        }
    };

    //BUSCAR CONTRATO
    const handleSearchContract = useCallback(async (page = 1) => {
        try {
            const params = new URLSearchParams();
            if (searchTermContract) params.append('search', searchTermContract);

            const response = await apiClient.get(`/contracts?${params.toString()}&page=${page}`);

            if (Array.isArray(response.data.results)) {
                setContractData(response.data.results);
            } else {
                setContractData([response.data.results]);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        }
    }, [searchTermContract]);

    useEffect(() => {
        if (!isContractSelected) {
            const delayDebounceFn = setTimeout(() => {
                if (searchTermContract) {
                    handleSearchContract();
                }
            }, 200);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [searchTermContract, handleSearchContract, isContractSelected]);

    const handleContractChange = (selectedOption) => {
        if (selectedOption) {
            setContract(selectedOption.value);
            setContractSearch(selectedOption.label);
            //setContractData([]);
        } else {
            setContract("");
            setContractSearch("");
        }

        if (isContractSelected) {
            setIsContractSelected(false);
        } else {
            setIsContractSelected(true);
        }
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setLoading(true);
            const payload = {
                contract,
                customer
            };
            await apiClient.post("/admin/reassign_contract", payload);
            setIsSuccessVisible(true);
            setIsErrorVisible(false);
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        } catch (error) {
            if (error.response?.data?.message.startsWith("CUSTOMER_DOES_NOT_HAVE_DISTRIBUTOR")) {
                setMessageBlock(`No se puede reasingar al Cliente debido a:
                                El cliente No tiene un Ditribuidor asociado.`)
                SetNotificationBlock(true);
            }
            setIsErrorVisible(true);
            setIsSuccessVisible(false);
            setTimeout(() => {
                setIsErrorVisible(false);
            }, 4000);
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        } finally {
            setLoading(false);
        }

    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Gestión de Clientes" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={handleClick}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Asignación de Contrato a nuevo Cliente</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.contract ? "red" : "revert-layer" }}>Nro. Contrato</label>
                        <Select
                            inputValue={searchTermContract}
                            onInputChange={(val) => setSearchTermContract(val)}
                            value={
                                contract
                                    ? {
                                        value: contract,
                                        label: contractSearch
                                    }
                                    : null
                            }
                            onChange={handleContractChange}
                            options={contractData.map((contrato) => ({
                                value: contrato.numCont,
                                label: contrato.numCont,
                            }))}
                            placeholder="Seleccione un Contrato"
                            isClearable
                            classNamePrefix="custom-select"
                            className="custom-select-container"
                        />
                        {errors.contract && <p className="error-message">{errors.contract}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.customer ? "red" : "revert-layer" }}>Cliente</label>
                        <Select
                            inputValue={searchTermClient}
                            onInputChange={(val) => setSearchTermClient(val)}
                            value={
                                customer
                                    ? {
                                        value: customer,
                                        label: clientSearch
                                    }
                                    : null
                            }
                            onChange={handleClientChange}
                            options={clientsData.map((cliente) => ({
                                value: cliente.code,
                                label: cliente.socialReason,
                            }))}
                            placeholder="Seleccione un Cliente"
                            isClearable
                            classNamePrefix="custom-select"
                            className="custom-select-container"
                        />
                        {errors.customer && <p className="error-message">{errors.customer}</p>}
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(-1);
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button className="basic-custom-button" onClick={handleSave}>
                        <FontAwesomeIcon
                            icon={faSave}
                            className="basic-shortcut-icon"
                        />
                        Reasignar
                    </button>
                </div>
            </div>
            {loading && <Loader />}
            <SuccessNotification
                message={"El Contrato se ha Reasignado Correctamente."}
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message="Hubo un problema al Reasignar el Contrato. Inténtalo de nuevo."
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isInfoVisible}
                onClose={() => setIsInfoVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={messageBlock}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={false}
                    whatsApp={false} 
                />
            )}
        </div>
    );
};

export default ContractReassignment;
